// 功能總開關（build 時由環境變數注入）。

// 訂閱 / 金流功能總開關：
// VITE_BILLING_ENABLE=true 時才顯示「訂閱管理」選單入口與路由；
// 未設定或非 'true' 一律視為關閉（隱藏訂閱相關 UI 與路由）。
export const isBillingEnabled = import.meta.env.VITE_BILLING_ENABLE === 'true';
